import styled from 'styled-components';
import FlavourConfig from '../../../../shared/config/flavours';
import Screen from '../../../../shared/utils/screen';

const AccessLogo = styled.img<React.CSSProperties>`
  left: ${114 * Screen.widthRatio}px;
  width: ${FlavourConfig.sizes.accessLogo}px;
  top: ${62 * Screen.widthRatio}px;
  position: absolute;
`;

AccessLogo.defaultProps = {
  src: FlavourConfig.images.logo,
};

export default AccessLogo;
